import { Typography, TypographyProps, Box, IconButton } from "@mui/material"
import { MouseEvent, ReactElement } from "react"

import { snackbar } from "../../../utils/general/generalUtils"
import AppTooltip from "../../helper/appTooltip"

interface ICopyTypographyProps {
    text: string
    typographyProps?: TypographyProps
    customTooltip?: string
    customCopyText?: string
    endIcon?: ReactElement
}

/**
 * Extends material-ui Typography component to copy text to clipboard on click.
 * Triggers a snackbar to notify user of successful copy. Stops propagation of
 * click event from any parent components.
 */
const CopyTypography = ({
    text,
    typographyProps,
    customTooltip,
    customCopyText,
    endIcon = undefined,
}: ICopyTypographyProps): ReactElement => {
    const copyText = customCopyText ?? text
    const handleClick = (e: MouseEvent<HTMLElement>): void => {
        e.stopPropagation()
        navigator.clipboard.writeText(copyText)
        snackbar("Copied to clipboard!", "default")
    }

    return (
        <AppTooltip title={customTooltip || "Click to copy to clipboard!"}>
            <Box display="flex" flexDirection="row" alignItems="center">
                <Typography
                    sx={{ cursor: "pointer" }}
                    onClick={handleClick}
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...typographyProps}
                >
                    {text}
                </Typography>
                {endIcon && (
                    <IconButton onClick={handleClick}>{endIcon}</IconButton>
                )}
            </Box>
        </AppTooltip>
    )
}

CopyTypography.defaultProps = {
    typographyProps: {},
    customTooltip: "",
    customCopyText: null,
    endIcon: undefined,
}

export default CopyTypography
